import React from 'react';
import PropTypes from 'prop-types';
import { UserDocsList } from 'Resources/UserDocsList';
import ErrorBoundary from '_components/ErrorBoundary';
import UpdateEmployeeTraining from 'EmployeeTraining';
import UserQualifications from 'UserQualifications';
import Management from 'Settings/Management';
import ApplicantsTab from 'ApplicantTab';
import ViewProfile from '_components/Profile/ViewProfile';
import { ApplicationHistory } from 'Applicants/ApplicationHistory';

const TabContent = ({
  activeTab,
  hash,
  permList,
  reloadKey,
  authUser,
  userData,
  applnType,
  email,
  onSendMail,
  onViewHistory,
  onViewDetails,
  onGoBack,
}) => {
  const renderTabContent = () => {
    switch (activeTab) {
      case 'profile':
        // Only render ViewProfile when hash is available to prevent undefined userHash warning
        return hash ? (
          <ViewProfile
            userHash={hash}
            authUser={authUser}
            permList={permList}
            changeTab={() => {}} // This will be handled by parent
            reloadKey={reloadKey}
          />
        ) : (
          // Show loading state when hash is not yet available
          <div className='dashboard_expiration_date_no_data'>
            <img
              className='loader'
              alt='Loader'
              src={require('../../assets/images/loader.gif').default}
            />
          </div>
        );

      case 'documents':
        return <UserDocsList userHash={hash} />;

      case 'trainings':
        return (
          <ErrorBoundary>
            <UpdateEmployeeTraining userHash={hash} />
          </ErrorBoundary>
        );

      case 'qualifications':
        return (
          <ErrorBoundary>
            <UserQualifications />
          </ErrorBoundary>
        );

      case 'management':
        return (
          <ErrorBoundary>
            <Management />
          </ErrorBoundary>
        );

      case 'application':
        return (
          <ErrorBoundary>
            <ApplicantsTab
              hash={userData?.applicant_hash}
              isApplicationEditable={false}
              applnType={applnType}
              email={email}
              sendMail={onSendMail}
              viewHistory={onViewHistory}
            />
          </ErrorBoundary>
        );

      case 'ApplicationHistory':
        return (
          <ErrorBoundary>
            <ApplicationHistory
              hash={hash}
              applnType={applnType}
              goBack={onGoBack}
              viewDetails={onViewDetails}
            />
          </ErrorBoundary>
        );

      default:
        return null;
    }
  };

  return (
    <div className='content_div settings profile--tab'>
      <div className='clearFix' />
      {renderTabContent()}
    </div>
  );
};

TabContent.propTypes = {
  activeTab: PropTypes.string.isRequired,
  hash: PropTypes.string,
  permList: PropTypes.array,
  reloadKey: PropTypes.number,
  authUser: PropTypes.object,
  userData: PropTypes.object,
  applnType: PropTypes.string,
  email: PropTypes.bool,
  onSendMail: PropTypes.func,
  onViewHistory: PropTypes.func,
  onViewDetails: PropTypes.func,
  onGoBack: PropTypes.func,
};

export default TabContent;
